(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*!
 * Crypto-JS v1.1.0
 * http://code.google.com/p/crypto-js/
 * Copyright (c) 2009, Jeff Mott. All rights reserved.
 * http://code.google.com/p/crypto-js/wiki/License
 */

var Crypto = {};

(function () {

	var base64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

	// Crypto utilities
	var util = Crypto.util = {

		// Bit-wise rotate left
		rotl: function rotl(n, b) {
			return n << b | n >>> 32 - b;
		},

		// Bit-wise rotate right
		rotr: function rotr(n, b) {
			return n << 32 - b | n >>> b;
		},

		// Swap big-endian to little-endian and vice versa
		endian: function endian(n) {

			// If number given, swap endian
			if (n.constructor == Number) {
				return util.rotl(n, 8) & 0x00FF00FF | util.rotl(n, 24) & 0xFF00FF00;
			}

			// Else, assume array and swap all items
			for (var i = 0; i < n.length; i++) {
				n[i] = util.endian(n[i]);
			}return n;
		},

		// Generate an array of any length of random bytes
		randomBytes: function randomBytes(n) {
			for (var bytes = []; n > 0; n--) {
				bytes.push(Math.floor(Math.random() * 256));
			}return bytes;
		},

		// Convert a string to a byte array
		stringToBytes: function stringToBytes(str) {
			var bytes = [];
			for (var i = 0; i < str.length; i++) {
				bytes.push(str.charCodeAt(i));
			}return bytes;
		},

		// Convert a byte array to a string
		bytesToString: function bytesToString(bytes) {
			var str = [];
			for (var i = 0; i < bytes.length; i++) {
				str.push(String.fromCharCode(bytes[i]));
			}return str.join("");
		},

		// Convert a string to big-endian 32-bit words
		stringToWords: function stringToWords(str) {
			var words = [];
			for (var c = 0, b = 0; c < str.length; c++, b += 8) {
				words[b >>> 5] |= str.charCodeAt(c) << 24 - b % 32;
			}return words;
		},

		// Convert a byte array to big-endian 32-bits words
		bytesToWords: function bytesToWords(bytes) {
			var words = [];
			for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
				words[b >>> 5] |= bytes[i] << 24 - b % 32;
			}return words;
		},

		// Convert big-endian 32-bit words to a byte array
		wordsToBytes: function wordsToBytes(words) {
			var bytes = [];
			for (var b = 0; b < words.length * 32; b += 8) {
				bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
			}return bytes;
		},

		// Convert a byte array to a hex string
		bytesToHex: function bytesToHex(bytes) {
			var hex = [];
			for (var i = 0; i < bytes.length; i++) {
				hex.push((bytes[i] >>> 4).toString(16));
				hex.push((bytes[i] & 0xF).toString(16));
			}
			return hex.join("");
		},

		// Convert a hex string to a byte array
		hexToBytes: function hexToBytes(hex) {
			var bytes = [];
			for (var c = 0; c < hex.length; c += 2) {
				bytes.push(parseInt(hex.substr(c, 2), 16));
			}return bytes;
		},

		// Convert a byte array to a base-64 string
		bytesToBase64: function bytesToBase64(bytes) {

			// Use browser-native function if it exists
			if (typeof btoa == "function") return btoa(util.bytesToString(bytes));

			var base64 = [],
			    overflow;

			for (var i = 0; i < bytes.length; i++) {
				switch (i % 3) {
					case 0:
						base64.push(base64map.charAt(bytes[i] >>> 2));
						overflow = (bytes[i] & 0x3) << 4;
						break;
					case 1:
						base64.push(base64map.charAt(overflow | bytes[i] >>> 4));
						overflow = (bytes[i] & 0xF) << 2;
						break;
					case 2:
						base64.push(base64map.charAt(overflow | bytes[i] >>> 6));
						base64.push(base64map.charAt(bytes[i] & 0x3F));
						overflow = -1;
				}
			}

			// Encode overflow bits, if there are any
			if (overflow != undefined && overflow != -1) base64.push(base64map.charAt(overflow));

			// Add padding
			while (base64.length % 4 != 0) {
				base64.push("=");
			}return base64.join("");
		},

		// Convert a base-64 string to a byte array
		base64ToBytes: function base64ToBytes(base64) {

			// Use browser-native function if it exists
			if (typeof atob == "function") return util.stringToBytes(atob(base64));

			// Remove non-base-64 characters
			base64 = base64.replace(/[^A-Z0-9+\/]/ig, "");

			var bytes = [];

			for (var i = 0; i < base64.length; i++) {
				switch (i % 4) {
					case 1:
						bytes.push(base64map.indexOf(base64.charAt(i - 1)) << 2 | base64map.indexOf(base64.charAt(i)) >>> 4);
						break;
					case 2:
						bytes.push((base64map.indexOf(base64.charAt(i - 1)) & 0xF) << 4 | base64map.indexOf(base64.charAt(i)) >>> 2);
						break;
					case 3:
						bytes.push((base64map.indexOf(base64.charAt(i - 1)) & 0x3) << 6 | base64map.indexOf(base64.charAt(i)));
						break;
				}
			}

			return bytes;
		}

	};

	// Crypto mode namespace
	Crypto.mode = {};
})();

module.exports = Crypto;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// padStart 的 polyfill，因为某些机型或情况，还无法支持es7的padStart，比如电脑版的微信小程序
// 所以这里做一个兼容polyfill的兼容处理
if (!String.prototype.padStart) {
	// 为了方便表示这里 fillString 用了ES6 的默认参数，不影响理解
	String.prototype.padStart = function (maxLength) {
		var fillString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';

		if (Object.prototype.toString.call(fillString) !== "[object String]") throw new TypeError('fillString must be String');
		var str = this;
		// 返回 String(str) 这里是为了使返回的值是字符串字面量，在控制台中更符合直觉
		if (str.length >= maxLength) return String(str);

		var fillLength = maxLength - str.length,
		    times = Math.ceil(fillLength / fillString.length);
		while (times >>= 1) {
			fillString += fillString;
			if (times === 1) {
				fillString += fillString;
			}
		}
		return fillString.slice(0, fillLength) + str;
	};
}

function timeFormat() {
	var timestamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-mm-dd';

	// 其他更多是格式化有如下:
	// yyyy:mm:dd|yyyy:mm|yyyy年mm月dd日|yyyy年mm月dd日 hh时MM分等,可自定义组合
	timestamp = parseInt(timestamp);
	// 如果为null,则格式化当前时间
	if (!timestamp) timestamp = Number(new Date());
	// 判断用户输入的时间戳是秒还是毫秒,一般前端js获取的时间戳是毫秒(13位),后端传过来的为秒(10位)
	if (timestamp.toString().length == 10) timestamp *= 1000;
	var date = new Date(timestamp);
	var ret = void 0;
	var opt = {
		"y+": date.getFullYear().toString(), // 年
		"m+": (date.getMonth() + 1).toString(), // 月
		"d+": date.getDate().toString(), // 日
		"h+": date.getHours().toString(), // 时
		"M+": date.getMinutes().toString(), // 分
		"s+": date.getSeconds().toString() // 秒
		// 有其他格式化字符需求可以继续添加，必须转化成字符串
	};
	for (var k in opt) {
		ret = new RegExp("(" + k + ")").exec(fmt);
		if (ret) {
			fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
		};
	};
	return fmt;
}

/* harmony default export */ __webpack_exports__["a"] = (timeFormat);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// 判断arr是否为一个数组，返回一个bool值
function isArray(arr) {
    return Object.prototype.toString.call(arr) === '[object Array]';
}

// 深度克隆
function deepClone(obj) {
    // 对常见的“非”值，直接返回原来值
    if ([null, undefined, NaN, false].includes(obj)) return obj;
    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== "object" && typeof obj !== 'function') {
        //原始类型直接返回
        return obj;
    }
    var o = isArray(obj) ? [] : {};
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
            o[i] = _typeof(obj[i]) === "object" ? deepClone(obj[i]) : obj[i];
        }
    }
    return o;
}

/* harmony default export */ __webpack_exports__["a"] = (deepClone);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * 验证电子邮箱格式
 */
function email(value) {
	return (/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(value)
	);
}

/**
 * 验证手机格式
 */
function mobile(value) {
	return (/^1[23456789]\d{9}$/.test(value)
	);
}

/**
 * 验证URL格式
 */
function url(value) {
	return (/^((https|http|ftp|rtsp|mms):\/\/)(([0-9a-zA-Z_!~*'().&=+$%-]+: )?[0-9a-zA-Z_!~*'().&=+$%-]+@)?(([0-9]{1,3}.){3}[0-9]{1,3}|([0-9a-zA-Z_!~*'()-]+.)*([0-9a-zA-Z][0-9a-zA-Z-]{0,61})?[0-9a-zA-Z].[a-zA-Z]{2,6})(:[0-9]{1,4})?((\/?)|(\/[0-9a-zA-Z_!~*'().;?:@&=+$,%#-]+)+\/?)$/.test(value)
	);
}

/**
 * 验证日期格式
 */
function date(value) {
	return !/Invalid|NaN/.test(new Date(value).toString());
}

/**
 * 验证ISO类型的日期格式
 */
function dateISO(value) {
	return (/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(value)
	);
}

/**
 * 验证十进制数字
 */
function number(value) {
	return (/^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value)
	);
}

/**
 * 验证整数
 */
function digits(value) {
	return (/^\d+$/.test(value)
	);
}

/**
 * 验证身份证号码
 */
function idCard(value) {
	return (/^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(value)
	);
}

/**
 * 是否车牌号
 */
function carNo(value) {
	// 新能源车牌
	var xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
	// 旧车牌
	var creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
	if (value.length === 7) {
		return creg.test(value);
	} else if (value.length === 8) {
		return xreg.test(value);
	} else {
		return false;
	}
}

/**
 * 金额,只允许2位小数
 */
function amount(value) {
	//金额，只允许保留两位小数
	return (/^[1-9]\d*(,\d{3})*(\.\d{1,2})?$|^0\.\d{1,2}$/.test(value)
	);
}

/**
 * 中文
 */
function chinese(value) {
	var reg = /^[\u4e00-\u9fa5]+$/gi;
	return reg.test(value);
}

/**
 * 只能输入字母
 */
function letter(value) {
	return (/^[a-zA-Z]*$/.test(value)
	);
}

/**
 * 只能是字母或者数字
 */
function enOrNum(value) {
	//英文或者数字
	var reg = /^[0-9a-zA-Z]*$/g;
	return reg.test(value);
}

/**
 * 验证是否包含某个值
 */
function contains(value, param) {
	return value.indexOf(param) >= 0;
}

/**
 * 验证一个值范围[min, max]
 */
function range(value, param) {
	return value >= param[0] && value <= param[1];
}

/**
 * 验证一个长度范围[min, max]
 */
function rangeLength(value, param) {
	return value.length >= param[0] && value.length <= param[1];
}

/**
 * 是否固定电话
 */
function landline(value) {
	var reg = /^\d{3,4}-\d{7,8}(-\d{3,4})?$/;
	return reg.test(value);
}

/**
 * 判断是否为空
 */
function empty(value) {
	switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
		case 'undefined':
			return true;
		case 'string':
			if (value.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true;
			break;
		case 'boolean':
			if (!value) return true;
			break;
		case 'number':
			if (0 === value || isNaN(value)) return true;
			break;
		case 'object':
			if (null === value || value.length === 0) return true;
			for (var i in value) {
				return false;
			}
			return true;
	}
	return false;
}

/**
 * 是否json字符串
 */
function jsonString(value) {
	if (typeof value == 'string') {
		try {
			var obj = JSON.parse(value);
			if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) == 'object' && obj) {
				return true;
			} else {
				return false;
			}
		} catch (e) {
			return false;
		}
	}
	return false;
}

/**
 * 是否数组
 */
function array(value) {
	if (typeof Array.isArray === "function") {
		return Array.isArray(value);
	} else {
		return Object.prototype.toString.call(value) === "[object Array]";
	}
}

/**
 * 是否对象
 */
function object(value) {
	return Object.prototype.toString.call(value) === '[object Object]';
}

/**
 * 是否短信验证码
 */
function code(value) {
	var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;

	return new RegExp('^\\d{' + len + '}$').test(value);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	email: email,
	mobile: mobile,
	url: url,
	date: date,
	dateISO: dateISO,
	number: number,
	digits: digits,
	idCard: idCard,
	carNo: carNo,
	amount: amount,
	chinese: chinese,
	letter: letter,
	enOrNum: enOrNum,
	contains: contains,
	range: range,
	rangeLength: rangeLength,
	empty: empty,
	isEmpty: empty,
	jsonString: jsonString,
	landline: landline,
	object: object,
	array: array,
	code: code
});

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var Base64 = {

    // private property
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

    // public method for encoding
    encode: function encode(input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;

        input = Base64._utf8_encode(input);

        while (i < input.length) {

            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = (chr1 & 3) << 4 | chr2 >> 4;
            enc3 = (chr2 & 15) << 2 | chr3 >> 6;
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
        }

        return output;
    },

    // public method for decoding
    decode: function decode(input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        while (i < input.length) {

            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));

            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }
        }

        output = Base64._utf8_decode(output);

        return output;
    },

    // private method for UTF-8 encoding
    _utf8_encode: function _utf8_encode(string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";

        for (var n = 0; n < string.length; n++) {

            var c = string.charCodeAt(n);

            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode(c >> 6 | 192);
                utftext += String.fromCharCode(c & 63 | 128);
            } else {
                utftext += String.fromCharCode(c >> 12 | 224);
                utftext += String.fromCharCode(c >> 6 & 63 | 128);
                utftext += String.fromCharCode(c & 63 | 128);
            }
        }

        return utftext;
    },

    // private method for UTF-8 decoding
    _utf8_decode: function _utf8_decode(utftext) {
        var string = "";
        var i = 0;
        var c = c1 = c2 = 0;

        while (i < utftext.length) {

            c = utftext.charCodeAt(i);

            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if (c > 191 && c < 224) {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode((c & 31) << 6 | c2 & 63);
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                i += 3;
            }
        }

        return string;
    }
};

module.exports = Base64;

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_mixin_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_mixin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mixin_mixin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__function_timeFormat_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__function_timeFrom_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__function_colorGradient_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__function_guid_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__function_color_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__function_type2icon_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__function_randomArray_js__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__function_deepClone_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__function_deepMerge_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__function_addUnit_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__function_test_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__function_random_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__function_trim_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__function_toast_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__function_getParent_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__function_parent_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__function_sys_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__function_debounce_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__function_throttle_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__OBS_OBSUploadFile_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__OBS_OBSUploadFile_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__OBS_OBSUploadFile_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_version1_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_version1_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__common_version1_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__config_config_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__config_zIndex_js__ = __webpack_require__(31);
// 引入全局mixin

// 引入关于是否mixin集成小程序分享的配置
// import wxshare from './mixin/mpShare.js'

// 尝试判断在根目录的/store中是否有$u.mixin.js，此文件uView默认为需要挂在到全局的vuex的state变量
// HX2.6.11版本,放到try中,控制台依然会警告,暂时不用此方式，
// let vuexStore = {};
// try {
// 	vuexStore = require("@/store/$u.mixin.js");
// } catch (e) {
// 	//TODO handle the exception
// }
// 时间格式化

// 时间戳格式化,返回多久之前

// 颜色渐变相关,colorGradient-颜色渐变,hexToRgb-十六进制颜色转rgb颜色,rgbToHex-rgb转十六进制

// 生成全局唯一guid字符串

// 主题相关颜色,info|success|warning|primary|default|error,此颜色已在uview.scss中定义,但是为js中也能使用,故也定义一份

// 根据type获取图标名称

// 打乱数组的顺序

// 对象和数组的深度克隆

// 对象深度拷贝

// 添加单位


// 规则检验

// 随机数

// 去除空格

// toast提示，对uni.showToast的封装

// 获取父组件参数

// 获取整个父组件

// 获取sys()和os()工具方法
// 获取设备信息，挂载到$u的sys()(system的缩写)属性中，
// 同时把安卓和ios平台的名称"ios"和"android"挂到$u.os()中，方便取用

// 防抖方法

// 节流方法






// 配置信息

// 各个需要fixed的地方的z-index配置文件


var $u = {
	timeFormat: __WEBPACK_IMPORTED_MODULE_1__function_timeFormat_js__["a" /* default */],
	date: __WEBPACK_IMPORTED_MODULE_1__function_timeFormat_js__["a" /* default */], // 另名date
	timeFrom: __WEBPACK_IMPORTED_MODULE_2__function_timeFrom_js__["a" /* default */],
	colorGradient: __WEBPACK_IMPORTED_MODULE_3__function_colorGradient_js__["a" /* default */].colorGradient,
	guid: __WEBPACK_IMPORTED_MODULE_4__function_guid_js__["a" /* default */],
	color: __WEBPACK_IMPORTED_MODULE_5__function_color_js__["a" /* default */],
	sys: __WEBPACK_IMPORTED_MODULE_17__function_sys_js__["b" /* sys */],
	os: __WEBPACK_IMPORTED_MODULE_17__function_sys_js__["a" /* os */],
	type2icon: __WEBPACK_IMPORTED_MODULE_6__function_type2icon_js__["a" /* default */],
	randomArray: __WEBPACK_IMPORTED_MODULE_7__function_randomArray_js__["a" /* default */],
	hexToRgb: __WEBPACK_IMPORTED_MODULE_3__function_colorGradient_js__["a" /* default */].hexToRgb,
	rgbToHex: __WEBPACK_IMPORTED_MODULE_3__function_colorGradient_js__["a" /* default */].rgbToHex,
	test: __WEBPACK_IMPORTED_MODULE_11__function_test_js__["a" /* default */],
	random: __WEBPACK_IMPORTED_MODULE_12__function_random_js__["a" /* default */],
	deepClone: __WEBPACK_IMPORTED_MODULE_8__function_deepClone_js__["a" /* default */],
	deepMerge: __WEBPACK_IMPORTED_MODULE_9__function_deepMerge_js__["a" /* default */],
	getParent: __WEBPACK_IMPORTED_MODULE_15__function_getParent_js__["a" /* default */],
	$parent: __WEBPACK_IMPORTED_MODULE_16__function_parent_js__["a" /* default */],
	addUnit: __WEBPACK_IMPORTED_MODULE_10__function_addUnit_js__["a" /* default */],
	trim: __WEBPACK_IMPORTED_MODULE_13__function_trim_js__["a" /* default */],
	type: ['primary', 'success', 'error', 'warning', 'info'],
	toast: __WEBPACK_IMPORTED_MODULE_14__function_toast_js__["a" /* default */],
	config: __WEBPACK_IMPORTED_MODULE_22__config_config_js__["a" /* default */], // uView配置信息相关，比如版本号
	zIndex: __WEBPACK_IMPORTED_MODULE_23__config_zIndex_js__["a" /* default */],
	debounce: __WEBPACK_IMPORTED_MODULE_18__function_debounce_js__["a" /* default */],
	throttle: __WEBPACK_IMPORTED_MODULE_19__function_throttle_js__["a" /* default */],
	OBSupload: __WEBPACK_IMPORTED_MODULE_20__OBS_OBSUploadFile_js___default.a,
	commonData: __WEBPACK_IMPORTED_MODULE_21__common_version1_js__
};

var install = function install(Vue) {
	Vue.mixin(__WEBPACK_IMPORTED_MODULE_0__mixin_mixin_js___default.a);
	if (Vue.prototype.openShare) {
		Vue.mixin(mpShare);
	}
	// Vue.mixin(vuexStore);
	// 时间格式化，同时两个名称，date和timeFormat
	Vue.filter('timeFormat', function (timestamp, format) {
		return Object(__WEBPACK_IMPORTED_MODULE_1__function_timeFormat_js__["a" /* default */])(timestamp, format);
	});
	Vue.filter('date', function (timestamp, format) {
		return Object(__WEBPACK_IMPORTED_MODULE_1__function_timeFormat_js__["a" /* default */])(timestamp, format);
	});
	// 将多久以前的方法，注入到全局过滤器
	Vue.filter('timeFrom', function (timestamp, format) {
		return Object(__WEBPACK_IMPORTED_MODULE_2__function_timeFrom_js__["a" /* default */])(timestamp, format);
	});
	Vue.prototype.$u = $u;
};

/* harmony default export */ __webpack_exports__["default"] = ({
	install: install
});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = {
	data: function data() {
		return {};
	},
	onLoad: function onLoad() {
		// getRect挂载到$u上，因为这方法需要使用in(this)，所以无法把它独立成一个单独的文件导出
		this.$u.getRect = this.$uGetRect;
	},

	methods: {
		// 查询节点信息
		// 目前此方法在支付宝小程序中无法获取组件跟接点的尺寸，为支付宝的bug(2020-07-21)
		// 解决办法为在组件根部再套一个没有任何作用的view元素
		$uGetRect: function $uGetRect(selector, all) {
			var _this = this;

			return new Promise(function (resolve) {
				uni.createSelectorQuery().in(_this)[all ? 'selectAll' : 'select'](selector).boundingClientRect(function (rect) {
					if (all && Array.isArray(rect) && rect.length) {
						resolve(rect);
					}
					if (!all && rect) {
						resolve(rect);
					}
				}).exec();
			});
		}
	},
	onReachBottom: function onReachBottom() {
		uni.$emit('uOnReachBottom');
	}
};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_function_timeFormat_js__ = __webpack_require__(1);


/**
 * 时间戳转为多久之前
 * @param String timestamp 时间戳
 * @param String | Boolean format 如果为时间格式字符串，超出一定时间范围，返回固定的时间格式；
 * 如果为布尔值false，无论什么时间，都返回多久以前的格式
 */
function timeFrom() {
	var timestamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-mm-dd';

	if (timestamp == null) timestamp = Number(new Date());
	timestamp = parseInt(timestamp);
	// 判断用户输入的时间戳是秒还是毫秒,一般前端js获取的时间戳是毫秒(13位),后端传过来的为秒(10位)
	if (timestamp.toString().length == 10) timestamp *= 1000;
	var timer = new Date().getTime() - timestamp;
	timer = parseInt(timer / 1000);
	// 如果小于5分钟,则返回"刚刚",其他以此类推
	var tips = '';
	switch (true) {
		case timer < 300:
			tips = '刚刚';
			break;
		case timer >= 300 && timer < 3600:
			tips = parseInt(timer / 60) + '分钟前';
			break;
		case timer >= 3600 && timer < 86400:
			tips = parseInt(timer / 3600) + '小时前';
			break;
		case timer >= 86400 && timer < 2592000:
			tips = parseInt(timer / 86400) + '天前';
			break;
		default:
			// 如果format为false，则无论什么时间戳，都显示xx之前
			if (format === false) {
				if (timer >= 2592000 && timer < 365 * 86400) {
					tips = parseInt(timer / (86400 * 30)) + '个月前';
				} else {
					tips = parseInt(timer / (86400 * 365)) + '年前';
				}
			} else {
				tips = Object(__WEBPACK_IMPORTED_MODULE_0__libs_function_timeFormat_js__["a" /* default */])(timestamp, format);
			}
	}
	return tips;
}

/* harmony default export */ __webpack_exports__["a"] = (timeFrom);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 求两个颜色之间的渐变值
 * @param {string} startColor 开始的颜色
 * @param {string} endColor 结束的颜色
 * @param {number} step 颜色等分的份额
 * */
function colorGradient() {
	var startColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rgb(0, 0, 0)';
	var endColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rgb(255, 255, 255)';
	var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

	var startRGB = hexToRgb(startColor, false); //转换为rgb数组模式
	var startR = startRGB[0];
	var startG = startRGB[1];
	var startB = startRGB[2];

	var endRGB = hexToRgb(endColor, false);
	var endR = endRGB[0];
	var endG = endRGB[1];
	var endB = endRGB[2];

	var sR = (endR - startR) / step; //总差值
	var sG = (endG - startG) / step;
	var sB = (endB - startB) / step;
	var colorArr = [];
	for (var i = 0; i < step; i++) {
		//计算每一步的hex值 
		var hex = rgbToHex('rgb(' + Math.round(sR * i + startR) + ',' + Math.round(sG * i + startG) + ',' + Math.round(sB * i + startB) + ')');
		colorArr.push(hex);
	}
	return colorArr;
}

// 将hex表示方式转换为rgb表示方式(这里返回rgb数组模式)
function hexToRgb(sColor) {
	var str = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
	sColor = sColor.toLowerCase();
	if (sColor && reg.test(sColor)) {
		if (sColor.length === 4) {
			var sColorNew = "#";
			for (var i = 1; i < 4; i += 1) {
				sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
			}
			sColor = sColorNew;
		}
		//处理六位的颜色值
		var sColorChange = [];
		for (var _i = 1; _i < 7; _i += 2) {
			sColorChange.push(parseInt("0x" + sColor.slice(_i, _i + 2)));
		}
		if (!str) {
			return sColorChange;
		} else {
			return 'rgb(' + sColorChange[0] + ',' + sColorChange[1] + ',' + sColorChange[2] + ')';
		}
	} else if (/^(rgb|RGB)/.test(sColor)) {
		var arr = sColor.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
		return arr.map(function (val) {
			return Number(val);
		});
	} else {
		return sColor;
	}
};

// 将rgb表示方式转换为hex表示方式
function rgbToHex(rgb) {
	var _this = rgb;
	var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
	if (/^(rgb|RGB)/.test(_this)) {
		var aColor = _this.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
		var strHex = "#";
		for (var i = 0; i < aColor.length; i++) {
			var hex = Number(aColor[i]).toString(16);
			hex = String(hex).length == 1 ? 0 + '' + hex : hex; // 保证每个rgb的值为2位
			if (hex === "0") {
				hex += hex;
			}
			strHex += hex;
		}
		if (strHex.length !== 7) {
			strHex = _this;
		}
		return strHex;
	} else if (reg.test(_this)) {
		var aNum = _this.replace(/#/, "").split("");
		if (aNum.length === 6) {
			return _this;
		} else if (aNum.length === 3) {
			var numHex = "#";
			for (var _i2 = 0; _i2 < aNum.length; _i2 += 1) {
				numHex += aNum[_i2] + aNum[_i2];
			}
			return numHex;
		}
	} else {
		return _this;
	}
}

/* harmony default export */ __webpack_exports__["a"] = ({
	colorGradient: colorGradient,
	hexToRgb: hexToRgb,
	rgbToHex: rgbToHex
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 本算法来源于简书开源代码，详见：https://www.jianshu.com/p/fdbf293d0a85
 * 全局唯一标识符（uuid，Globally Unique Identifier）,也称作 uuid(Universally Unique IDentifier) 
 * 一般用于多个组件之间,给它一个唯一的标识符,或者v-for循环的时候,如果使用数组的index可能会导致更新列表出现问题
 * 最可能的情况是左滑删除item或者对某条信息流"不喜欢"并去掉它的时候,会导致组件内的数据可能出现错乱
 * v-for的时候,推荐使用后端返回的id而不是循环的index
 * @param {Number} len uuid的长度
 * @param {Boolean} firstU 将返回的首字母置为"u"
 * @param {Nubmer} radix 生成uuid的基数(意味着返回的字符串都是这个基数),2-二进制,8-八进制,10-十进制,16-十六进制
 */
function guid() {
	var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;
	var firstU = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	var radix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	var uuid = [];
	radix = radix || chars.length;

	if (len) {
		// 如果指定uuid长度,只是取随机的字符,0|x为位运算,能去掉x的小数位,返回整数位
		for (var i = 0; i < len; i++) {
			uuid[i] = chars[0 | Math.random() * radix];
		}
	} else {
		var r = void 0;
		// rfc4122标准要求返回的uuid中,某些位为固定的字符
		uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
		uuid[14] = '4';

		for (var _i = 0; _i < 36; _i++) {
			if (!uuid[_i]) {
				r = 0 | Math.random() * 16;
				uuid[_i] = chars[_i == 19 ? r & 0x3 | 0x8 : r];
			}
		}
	}
	// 移除第一个字符,并用u替代,因为第一个字符为数值时,该guuid不能用作id或者class
	if (firstU) {
		uuid.shift();
		return 'u' + uuid.join('');
	} else {
		return uuid.join('');
	}
}

/* harmony default export */ __webpack_exports__["a"] = (guid);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 为了让用户能够自定义主题，会逐步弃用此文件，各颜色通过css提供
// 为了给某些特殊场景使用和向后兼容，无需删除此文件(2020-06-20)
var color = {
	primary: "#2979ff",
	primaryDark: "#2b85e4",
	primaryDisabled: "#a0cfff",
	primaryLight: "#ecf5ff",
	bgColor: "#f3f4f6",

	info: "#909399",
	infoDark: "#82848a",
	infoDisabled: "#c8c9cc",
	infoLight: "#f4f4f5",

	warning: "#ff9900",
	warningDark: "#f29100",
	warningDisabled: "#fcbd71",
	warningLight: "#fdf6ec",

	error: "#fa3534",
	errorDark: "#dd6161",
	errorDisabled: "#fab6b6",
	errorLight: "#fef0f0",

	success: "#19be6b",
	successDark: "#18b566",
	successDisabled: "#71d5a1",
	successLight: "#dbf1e1",

	mainColor: "#303133",
	contentColor: "#606266",
	tipsColor: "#909399",
	lightColor: "#c0c4cc",
	borderColor: "#e4e7ed"
};

/* harmony default export */ __webpack_exports__["a"] = (color);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 根据主题type值,获取对应的图标
 * @param String type 主题名称,primary|info|error|warning|success
 * @param String fill 是否使用fill填充实体的图标  
 */
function type2icon() {
	var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'success';
	var fill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	// 如果非预置值,默认为success
	if (['primary', 'info', 'error', 'warning', 'success'].indexOf(type) == -1) type = 'success';
	var iconName = '';
	// 目前(2019-12-12),info和primary使用同一个图标
	switch (type) {
		case 'primary':
			iconName = 'info-circle';
			break;
		case 'info':
			iconName = 'info-circle';
			break;
		case 'error':
			iconName = 'close-circle';
			break;
		case 'warning':
			iconName = 'error-circle';
			break;
		case 'success':
			iconName = 'checkmark-circle';
			break;
		default:
			iconName = 'checkmark-circle';
	}
	// 是否是实体类型,加上-fill,在icon组件库中,实体的类名是后面加-fill的
	if (fill) iconName += '-fill';
	return iconName;
}

/* harmony default export */ __webpack_exports__["a"] = (type2icon);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 打乱数组
function randomArray() {
	var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	// 原理是sort排序,Math.random()产生0<= x < 1之间的数,会导致x-0.05大于或者小于0
	return array.sort(function () {
		return Math.random() - 0.5;
	});
}

/* harmony default export */ __webpack_exports__["a"] = (randomArray);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deepClone__ = __webpack_require__(2);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



// JS对象深度合并
function deepMerge() {
	var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	target = Object(__WEBPACK_IMPORTED_MODULE_0__deepClone__["a" /* default */])(target);
	if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object' || (typeof source === 'undefined' ? 'undefined' : _typeof(source)) !== 'object') return false;
	for (var prop in source) {
		if (!source.hasOwnProperty(prop)) continue;
		if (prop in target) {
			if (_typeof(target[prop]) !== 'object') {
				target[prop] = source[prop];
			} else {
				if (_typeof(source[prop]) !== 'object') {
					target[prop] = source[prop];
				} else {
					if (target[prop].concat && source[prop].concat) {
						target[prop] = target[prop].concat(source[prop]);
					} else {
						target[prop] = deepMerge(target[prop], source[prop]);
					}
				}
			}
		} else {
			target[prop] = source[prop];
		}
	}
	return target;
}

/* harmony default export */ __webpack_exports__["a"] = (deepMerge);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addUnit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__test_js__ = __webpack_require__(3);


// 添加单位，如果有rpx，%，px等单位结尾或者值为auto，直接返回，否则加上rpx单位结尾
function addUnit() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rpx';

    value = String(value);
    // 用uView内置验证规则中的number判断是否为数值
    return __WEBPACK_IMPORTED_MODULE_0__test_js__["a" /* default */].number(value) ? '' + value + unit : value;
}

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function random(min, max) {
	if (min >= 0 && max > 0 && max >= min) {
		var gab = max - min + 1;
		return Math.floor(Math.random() * gab + min);
	} else {
		return 0;
	}
}

/* harmony default export */ __webpack_exports__["a"] = (random);

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function trim(str) {
	var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'both';

	if (pos == 'both') {
		return str.replace(/^\s+|\s+$/g, "");
	} else if (pos == "left") {
		return str.replace(/^\s*/, '');
	} else if (pos == 'right') {
		return str.replace(/(\s*$)/g, "");
	} else if (pos == 'all') {
		return str.replace(/\s+/g, "");
	} else {
		return str;
	}
}

/* harmony default export */ __webpack_exports__["a"] = (trim);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toast(title) {
	var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;

	uni.showToast({
		title: title,
		icon: 'none',
		duration: duration
	});
}

/* harmony default export */ __webpack_exports__["a"] = (toast);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getParent;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// 获取父组件的参数，因为支付宝小程序不支持provide/inject的写法
// this.$parent在非H5中，可以准确获取到父组件，但是在H5中，需要多次this.$parent.$parent.xxx
function getParent(name, keys) {
	var parent = this.$parent;
	// 通过while历遍，这里主要是为了H5需要多层解析的问题
	while (parent) {
		// 父组件
		if (parent.$options.name !== name) {
			// 如果组件的name不相等，继续上一级寻找
			parent = parent.$parent;
		} else {
			var _ret = function () {
				var data = {};
				// 判断keys是否数组，如果传过来的是一个数组，那么直接使用数组元素值当做键值去父组件寻找
				if (Array.isArray(keys)) {
					keys.map(function (val) {
						data[val] = parent[val] ? parent[val] : '';
					});
				} else {
					// 历遍传过来的对象参数
					for (var i in keys) {
						// 如果子组件有此值则用，无此值则用父组件的值
						// 判断是否空数组，如果是，则用父组件的值，否则用子组件的值
						if (Array.isArray(keys[i])) {
							if (keys[i].length) {
								data[i] = keys[i];
							} else {
								data[i] = parent[i];
							}
						} else if (keys[i].constructor === Object) {
							// 判断是否对象，如果是对象，且有属性，那么使用子组件的值，否则使用父组件的值
							if (Object.keys(keys[i]).length) {
								data[i] = keys[i];
							} else {
								data[i] = parent[i];
							}
						} else {
							// 只要子组件有传值，即使是false值，也是“传值”了，也需要覆盖父组件的同名参数
							data[i] = keys[i] || keys[i] === false ? keys[i] : parent[i];
						}
					}
				}
				return {
					v: data
				};
			}();

			if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		}
	}

	return {};
}

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = $parent;
// 获取父组件的参数，因为支付宝小程序不支持provide/inject的写法
// this.$parent在非H5中，可以准确获取到父组件，但是在H5中，需要多次this.$parent.$parent.xxx
// 这里默认值等于undefined有它的含义，因为最顶层元素(组件)的$parent就是undefined，意味着不传name
// 值(默认为undefined)，就是查找最顶层的$parent
function $parent() {
	var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

	var parent = this.$parent;
	// 通过while历遍，这里主要是为了H5需要多层解析的问题
	while (parent) {
		// 父组件
		if (parent.$options && parent.$options.name !== name) {
			// 如果组件的name不相等，继续上一级寻找
			parent = parent.$parent;
		} else {
			return parent;
		}
	}
	return false;
}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = os;
/* harmony export (immutable) */ __webpack_exports__["b"] = sys;
function os() {
	return uni.getSystemInfoSync().platform;
};

function sys() {
	return uni.getSystemInfoSync();
}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var timeout = null;

/**
 * 防抖原理：一定时间内，只有最后一次操作，再过wait毫秒后才执行函数
 * 
 * @param {Function} func 要执行的回调函数 
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行 
 * @return null
 */
function debounce(func) {
	var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	// 清除定时器
	if (timeout !== null) clearTimeout(timeout);
	// 立即执行，此类情况一般用不到
	if (immediate) {
		var callNow = !timeout;
		timeout = setTimeout(function () {
			timeout = null;
		}, wait);
		if (callNow) typeof func === 'function' && func();
	} else {
		// 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
		timeout = setTimeout(function () {
			typeof func === 'function' && func();
		}, wait);
	}
}

/* harmony default export */ __webpack_exports__["a"] = (debounce);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var timer = void 0,
    flag = void 0;
/**
 * 节流原理：在一定时间内，只能触发一次
 * 
 * @param {Function} func 要执行的回调函数 
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 * @return null
 */
function throttle(func) {
	var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	if (immediate) {
		if (!flag) {
			flag = true;
			// 如果是立即执行，则在wait毫秒内开始时执行
			typeof func === 'function' && func();
			timer = setTimeout(function () {
				flag = false;
			}, wait);
		}
	} else {
		if (!flag) {
			flag = true;
			// 如果是非立即执行，则在wait毫秒内的结束处执行
			timer = setTimeout(function () {
				flag = false;
				typeof func === 'function' && func();
			}, wait);
		}
	}
};
/* harmony default export */ __webpack_exports__["a"] = (throttle);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var config = __webpack_require__(24);
var getPolicyEncode = __webpack_require__(25);
var getSignature = __webpack_require__(26);

var OBSupload = function OBSupload(filePath) {
  if (!filePath) {
    wx.showToast({
      title: '文件路径不能为空',
      icon: '请重新选择路径'
    });
  } else {
    var openId = uni.getStorageSync('userInfo').openId;
    var time = new Date().getTime();
    var fileName = 'patient/' + time + (openId + '.jpg'); //指定上传到OBS桶中的对象名
    var OBSPolicy = { //设定policy内容
      "expiration": "2030-12-31T12:00:00.000Z",
      "conditions": [{ "bucket": "hes" }, //Bucket name
      { 'key': fileName }]
    };

    wx.setStorageSync('fileName', fileName);

    var policyEncoded = getPolicyEncode(OBSPolicy); //计算policy编码值
    var signature = getSignature(policyEncoded, config.SecretKey); //计算signature

    wx.uploadFile({
      url: config.EndPoint,
      filePath: filePath,
      name: 'file',
      header: {
        'content-type': 'multipart/form-data; boundary=-9431149156168'
      },
      formData: {
        'AccessKeyID': config.AccessKeyId,
        'policy': policyEncoded,
        'signature': signature,
        'key': fileName
      },
      success: function success(res) {
        console.log(res); //打印响应状态码
        var statusCode = res.statusCode.toString();
        if (statusCode.startsWith('2')) {
          wx.showToast({
            title: '上传成功',
            icon: '成功'
          });
        } else {
          console.log('上传图片失败', res);
          wx.showToast({
            title: '上传失败',
            icon: '失败'
          });
          return false;
        }
      },
      fail: function fail(e) {
        console.log(e);
      }
    });
  }
};

module.exports = OBSupload;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

//指定OBS服务相关信息：AK，SK，EndPoint
var Configuration = {
  AccessKeyId: 'FRMXQCPA4OCRVB98FKWQ', //AK
  SecretKey: 'MTek9apznJHxIpwfUkFwX6aef4vRlInckBMPMuTv', //SK
  EndPoint: 'https://hes.obs.cn-east-2.myhuaweicloud.com/' //上传文件的路径
};

module.exports = Configuration;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var Base64 = __webpack_require__(4);

function getPolicyEncode(policy) {
  var encodedPolicy = Base64.encode(JSON.stringify(policy));
  return encodedPolicy;
}

module.exports = getPolicyEncode;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(27);
__webpack_require__(28);
var Crypto = __webpack_require__(0);
var Base64 = __webpack_require__(4);

//利用SK计算Signature信息
function getSignature(policyEncoded, SecretKey) {
  var bytes = Crypto.HMAC(Crypto.SHA1, policyEncoded, SecretKey, {
    asBytes: true
  });

  var signature = Crypto.util.bytesToBase64(bytes);
  return signature;
}

module.exports = getSignature;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Crypto-JS v1.1.0
 * http://code.google.com/p/crypto-js/
 * Copyright (c) 2009, Jeff Mott. All rights reserved.
 * http://code.google.com/p/crypto-js/wiki/License
 */

var Crypto = __webpack_require__(0);

(function () {

	// Shortcut
	var util = Crypto.util;

	Crypto.HMAC = function (hasher, message, key, options) {

		// Allow arbitrary length keys
		key = key.length > hasher._blocksize * 4 ? hasher(key, { asBytes: true }) : util.stringToBytes(key);

		// XOR keys with pad constants
		var okey = key,
		    ikey = key.slice(0);
		for (var i = 0; i < hasher._blocksize * 4; i++) {
			okey[i] ^= 0x5C;
			ikey[i] ^= 0x36;
		}

		var hmacbytes = hasher(util.bytesToString(okey) + hasher(util.bytesToString(ikey) + message, { asString: true }), { asBytes: true });
		return options && options.asBytes ? hmacbytes : options && options.asString ? util.bytesToString(hmacbytes) : util.bytesToHex(hmacbytes);
	};
})();

module.exports = Crypto;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Crypto-JS v1.1.0
 * http://code.google.com/p/crypto-js/
 * Copyright (c) 2009, Jeff Mott. All rights reserved.
 * http://code.google.com/p/crypto-js/wiki/License
 */

var Crypto = __webpack_require__(0);

(function () {

	// Shortcut
	var util = Crypto.util;

	// Public API
	var SHA1 = Crypto.SHA1 = function (message, options) {
		var digestbytes = util.wordsToBytes(SHA1._sha1(message));
		return options && options.asBytes ? digestbytes : options && options.asString ? util.bytesToString(digestbytes) : util.bytesToHex(digestbytes);
	};

	// The core
	SHA1._sha1 = function (message) {

		var m = util.stringToWords(message),
		    l = message.length * 8,
		    w = [],
		    H0 = 1732584193,
		    H1 = -271733879,
		    H2 = -1732584194,
		    H3 = 271733878,
		    H4 = -1009589776;

		// Padding
		m[l >> 5] |= 0x80 << 24 - l % 32;
		m[(l + 64 >>> 9 << 4) + 15] = l;

		for (var i = 0; i < m.length; i += 16) {

			var a = H0,
			    b = H1,
			    c = H2,
			    d = H3,
			    e = H4;

			for (var j = 0; j < 80; j++) {

				if (j < 16) w[j] = m[i + j];else {
					var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16];
					w[j] = n << 1 | n >>> 31;
				}

				var t = (H0 << 5 | H0 >>> 27) + H4 + (w[j] >>> 0) + (j < 20 ? (H1 & H2 | ~H1 & H3) + 1518500249 : j < 40 ? (H1 ^ H2 ^ H3) + 1859775393 : j < 60 ? (H1 & H2 | H1 & H3 | H2 & H3) - 1894007588 : (H1 ^ H2 ^ H3) - 899497514);

				H4 = H3;
				H3 = H2;
				H2 = H1 << 30 | H1 >>> 2;
				H1 = H0;
				H0 = t;
			}

			H0 += a;
			H1 += b;
			H2 += c;
			H3 += d;
			H4 += e;
		}

		return [H0, H1, H2, H3, H4];
	};

	// Package private blocksize
	SHA1._blocksize = 16;
})();

module.exports = Crypto;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

version1 = [{
    "name": '全部科室',
    "type": 'hierarchy',
    "submenu": [{
        "name": "全部科室",
        "value": "全部科室"
    }]
}, {
    "name": '全部职称',
    "type": 'hierarchy',
    "submenu": [{
        "name": "全部职称",
        "value": "全部职称"
    }, {
        "name": "主治医师",
        "value": "主治医师"
    }, {
        "name": "副主任医师",
        "value": "副主任医师"
    }, {
        "name": "科室专家",
        "value": "科室专家"
    }, {
        "name": "门诊医生",
        "value": "门诊医生"
    }]
}];

version2 = [{
    "name": '全部科室',
    "type": 'hierarchy',
    "submenu": [{
        "name": "全部科室",
        "value": "全部科室"
    }]
}];

loginMedicalservices = [{
    name: '我的订单',
    itemImage: [{
        name: '挂号订单',
        imgIcon: 'http://file.aihuihc.com/patient/patientImages/images/login/registerOrder.png'
    }, {
        name: '缴费订单',
        imgIcon: 'http://file.aihuihc.com/patient/patientImages/images/login/payOrder.png'
    }, {
        name: '咨询订单',
        imgIcon: 'http://file.aihuihc.com/patient/patientImages/images/login/consultingOrder.png'
    }, {
        name: '我的消息',
        imgIcon: 'http://file.aihuihc.com/patient/patientImages/images/login/myNews.png'
    }]
}, {
    name: '常用工具',
    itemImage: [{
        name: '健康卡',
        imgIcon: 'http://file.aihuihc.com/patient/patientImages/images/login/healthyCard.png'
    }, {
        name: '设置',
        imgIcon: 'http://file.aihuihc.com/patient/patientImages/images/login/setting.png'
    }]
}];

homeSkeleton = {
    videoFour: [{
        titleName: '免疫力如何提高？',
        pagePath: 'http://file.aihuihc.com/patient/patientImages/images/newHome/test1.mp4'
    }, {
        titleName: '头疼该怎么办？',
        pagePath: 'http://baobab.kaiyanapp.com/api/v1/playUrl?vid=196464&resourceType=video&editionType=default&source=aliyun&playUrlType=url_oss'
    }, {
        titleName: '免疫力如何提高？',
        pagePath: 'http://baobab.kaiyanapp.com/api/v1/playUrl?vid=169401&resourceType=video&editionType=default&source=aliyun&playUrlType=url_oss'
    }, {
        titleName: '头疼该怎么办？',
        pagePath: 'https://img.cdn.aliyun.dcloud.net.cn/guide/uniapp/%E7%AC%AC1%E8%AE%B2%EF%BC%88uni-app%E4%BA%A7%E5%93%81%E4%BB%8B%E7%BB%8D%EF%BC%89-%20DCloud%E5%AE%98%E6%96%B9%E8%A7%86%E9%A2%91%E6%95%99%E7%A8%8B@20200317.mp4'
    }],
    menuBarList: [{
        grade: 1,
        name: '预约挂号',
        imageUrl: ''
    }, {
        grade: 1,
        name: '在线就诊',
        imageUrl: ''
    }, {
        grade: 2,
        name: '体检报告',
        imageUrl: ''
    }, {
        grade: 2,
        name: '住院服务',
        imageUrl: ''
    }, {
        grade: 2,
        name: '检查检验报告',
        imageUrl: ''
    }, {
        grade: 2,
        name: '门诊病历',
        imageUrl: ''
    }, {
        grade: 2,
        name: '远程会诊',
        imageUrl: ''
    }]
};

module.exports = {
    version1: version1,
    version2: version2,
    homeSkeleton: homeSkeleton,
    loginMedicalservices: loginMedicalservices
};

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 此版本发布于2020-09-07
var version = '1.6.8';

/* harmony default export */ __webpack_exports__["a"] = ({
	v: version,
	version: version,
	// 主题名称
	type: ['primary', 'success', 'info', 'error', 'warning']
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// uniapp在H5中各API的z-index值如下：
/**
 * actionsheet: 999
 * modal: 999
 * navigate: 998
 * tabbar: 998
 * toast: 999
 */

/* harmony default export */ __webpack_exports__["a"] = ({
	toast: 10090,
	noNetwork: 10080,
	// popup包含popup，actionsheet，keyboard，picker的值
	popup: 10075,
	mask: 10070,
	navbar: 980,
	topTips: 975,
	sticky: 970,
	indexListSticky: 965
});

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js